import Loader from "../Loader/Button";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import AnimatedCheck from "../../Media/SVG/check.lottie";

export default function GradientBlue({
  type,
  value,
  onClick = "",
  isLoader = false,
  haveLottie = false,
}) {
  
  if (isLoader) {
    return (
      <button className="w-full bg-zi-buttonbg-primary text-zi-gray-light text-base py-[13px] rounded-lg outline-none flex justify-center items-center">
        <Loader />
      </button>
    );
  }

  if (haveLottie) {
    return (
      <button className="w-full bg-zi-buttonbg-primary text-zi-gray-light text-base py-[6px] rounded-lg outline-none flex justify-center items-center">
        <div className="h-7">
          <DotLottieReact
            src={AnimatedCheck}
            loop={false}
            autoplay={true}
          />
        </div>
      </button>
    );
  }
  return (
    <input
      className="w-full bg-zi-buttonbg-primary text-zi-gray-light text-base py-2 rounded-lg cursor-pointer outline-none hocus:opacity-85"
      type={type}
      value={value}
      onClick={onClick}
    ></input>
    
  );
}
